import { FC } from 'react';
import { Button } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: () => void;
  disabled?:boolean;
}

const ButtonImport: FC<IProps> = ({
  onClick,
  disabled
}) => {
  return (
    <Button
      onClick={() => onClick()}
      disabled={disabled || false}
    >
      <FontAwesomeIcon icon={faFileImport} className='me-2' />
      <span>{t("IMPORT")}</span>
    </Button>
  );
}

export default ButtonImport;